function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwindCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(29.411765%,53.72549%,67.45098%)",
      fillOpacity: 1
    },
    d: "M 370 190.199219 C 355 185.035156 341.761719 175.746094 331.800781 163.398438 C 309.550781 135.523438 275.664062 119.503906 240 120 C 190.910156 116.523438 147.382812 151.34375 140 200 C 154.390625 175.921875 182.671875 163.882812 210 170.199219 C 224.972656 175.515625 238.191406 184.859375 248.199219 197.199219 C 270.570312 224.851562 304.441406 240.640625 340 240 C 389.089844 243.476562 432.617188 208.65625 440 160 C 425.863281 184.382812 397.4375 196.644531 370 190.199219 Z M 110 289.800781 C 125 294.964844 138.238281 304.253906 148.199219 316.601562 C 170.449219 344.476562 204.335938 360.496094 240 360 C 289.089844 363.476562 332.617188 328.65625 340 280 C 325.609375 304.078125 297.328125 316.117188 270 309.800781 C 255.027344 304.484375 241.808594 295.140625 231.800781 282.800781 C 209.375 255.222656 175.542969 239.449219 140 240 C 90.910156 236.523438 47.382812 271.34375 40 320 C 54.136719 295.617188 82.5625 283.355469 110 289.800781 Z M 110 289.800781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwindCss);
export default __webpack_public_path__ + "static/media/tailwind-css.aa94cc96e3e93895a9b166753524f84d.svg";
export { ForwardRef as ReactComponent };